/**
 * Visual tokens for the Navigation Configuration Studio.
 * Aligns Product Menu Management with the enterprise admin design system.
 */
export const navigationStudio = {
  applicationSelectorWidth: 280,
  panelBorderRadius: 2,
  panelBorderColor: 'divider',
  panelBackground: 'background.paper',
  workspaceBackground: 'background.default',
  selectedApplicationBg: 'action.selected',
  selectedApplicationHoverBg: 'action.hover',
  selectedNodeBg: 'action.selected',
  selectedNodeHoverBg: 'action.hover',
  nodeHoverBg: 'action.hover',
  productIconBg: 'rgba(238, 46, 36, 0.14)',
  productIconColor: 'error.main',
  treeIndentPx: 20,
  treeRowMinHeight: 44,
  treeRowPaddingX: 1.5,
  sectionSpacing: 2.5,
  contentPadding: 2.5,
  propertyPanelBg: 'background.default',
  propertyPanelBorderTop: 'divider',
} as const;
